"use client";
// atoms/importedTokens.ts
import type { TokenConfigType } from '@/constants/project-specific';
import { atomWithStorage } from 'jotai/utils';

export type ImportedTokens = Record<number, TokenConfigType[]>;

// export const importedTokensAtom = atomWithStorage<ImportedTokens>('importedTokens', {}, indexedDBStorage as AsyncStorage<ImportedTokens>);

export const importedTokensAtom = atomWithStorage<ImportedTokens>('importedTokens', {})